"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainArrangementSortColumn = void 0;
var TrainArrangementSortColumn;
(function (TrainArrangementSortColumn) {
    TrainArrangementSortColumn["Description"] = "Description";
    TrainArrangementSortColumn["EndDate"] = "EndDate";
    TrainArrangementSortColumn["StartDate"] = "StartDate";
    TrainArrangementSortColumn["Type"] = "Type";
})(TrainArrangementSortColumn || (exports.TrainArrangementSortColumn = TrainArrangementSortColumn = {}));
//# sourceMappingURL=sort.js.map